import { render, staticRenderFns } from "./PreguntasDialog.vue?vue&type=template&id=285e2c82&scoped=true&"
import script from "./PreguntasDialog.vue?vue&type=script&lang=js&"
export * from "./PreguntasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e2c82",
  null
  
)

export default component.exports